import { Button, Modal, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { InfinityPagination } from "../hooks/Pagination";
import { InterviewCreate } from "../interfaces/Interview";
import { ManagerSearch, ManagerTable } from "../interfaces/Manager";
import { RequestTable } from "../interfaces/Request";
import { CreateInterview, GetManagers } from "../requester/functions";
import VO from "../utilities/validate";
import DataDateTime from "./DataInputs/DataDateTime";
import DataSelect from "./DataInputs/DataSelect";

const template: InterviewCreate = {
	id_request: 0,
	id_manager: 0,
	datetime: undefined,
};

interface IProps {
	open: boolean;
	onClose(): void;
	onCreate?(): void;
	userId?: number;
	request?: RequestTable;
}

const CreateInterviewModal = (props: IProps) => {
	const { enqueueSnackbar } = useSnackbar();

	const [interview, setInterview] = useState<InterviewCreate>(template);
	const [managers, setManagers] = useState<ManagerTable[]>([]);

	const [searchManager, setSearchManager] = useState<ManagerSearch>({});

	useEffect(() => {
		GetManagers(
			{
				search_by: searchManager,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setManagers(resp.data.data);
				}
			}
		);
	}, [searchManager]);

	useEffect(() => {
		setInterview((t) => {
			if (props.request) t.id_request = props.request?.id;
			else if (t.id_request) delete t.id_request;
			return { ...t };
		});
	}, [props.request]);

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center  flex-col justify-center  overflow-auto"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[800px] min-w-[400px]  flex flex-col gap-5">
				<Typography variant="h4">Создание интервью</Typography>
				{props.request ? (
					<Paper className="flex flex-col gap-2 p-1">
						<Typography>Заявка</Typography>
						<Typography>
							{props.request.candidate.full_name} / {props.request.vacancy.name}
						</Typography>
					</Paper>
				) : null}
				<DataSelect
					label="Ответственный"
					list={managers}
					value={interview}
					setValue={setInterview}
					keyTitle={"last_name"}
					keyValue={"id_manager"}
				/>
				<DataDateTime
					value={interview}
					setValue={setInterview}
					label="Дата отправки"
					keyValue={"datetime"}
				/>
				<Button
					disabled={!VO(interview, template)}
					variant="contained"
					onClick={() => {
						CreateInterview(interview, (resp) => {
							if (resp.status === "ok") {
								enqueueSnackbar("Интервью создано", {
									variant: "success",
								});
								props.onCreate?.();
								props.onClose();
							} else {
								enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
									variant: "error",
								});
							}
						});
					}}
				>
					Сохранить
				</Button>
			</Paper>
		</Modal>
	);
};

export default CreateInterviewModal;
